export default {
  "entrypoints": {
    "mainnavigation": {"php": true},
    "contact": {"php": false},
    "cookie-notice": {"php": false}
  }
}
